import { useState } from "react";
import { issueMeta, tickerItems } from "@/mocks/home";

const navItems = [
  { id: "collections", label: "合辑索引" },
  { id: "channels", label: "账号频道" },
  { id: "routes", label: "在哪看" },
  { id: "index", label: "速查索引" },
];

export default function TopBar() {
  const [open, setOpen] = useState(false);

  return (
    <header id="top" className="sticky top-0 z-50 w-full">
      <div className="w-full bg-primary-600 text-background-50">
        <div className="mx-auto flex h-9 w-full max-w-[1360px] items-center gap-4 px-4 md:px-8">
          <span className="hidden shrink-0 whitespace-nowrap text-xs tracking-wider md:inline">
            {issueMeta.date}
          </span>
          <span className="hidden h-3 w-px bg-background-50/40 md:inline-block"></span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker">
              {[...tickerItems, ...tickerItems].map((item, i) => (
                <span
                  key={i}
                  className="flex items-center whitespace-nowrap text-xs text-background-50/90"
                >
                  <span className="mx-3">{item}</span>
                  <span className="h-1 w-1 rounded-full bg-accent-400"></span>
                </span>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 whitespace-nowrap text-xs tracking-wider text-background-50/80 lg:inline">
            {issueMeta.issue}
          </span>
        </div>
      </div>

      <div className="w-full border-b-2 border-foreground-950/85 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 w-full max-w-[1360px] items-center justify-between gap-6 px-4 md:h-20 md:px-8">
          <a href="#top" className="flex cursor-pointer items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-bold text-background-50 md:h-10 md:w-10 md:text-xl">
              瓜
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-base font-bold tracking-tight text-foreground-950 md:text-lg">
                {issueMeta.brand}
              </span>
              <span className="hidden text-[11px] tracking-[0.28em] text-foreground-500 sm:block">
                GUA · DIRECTORY
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-8 md:flex">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="cursor-pointer whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#collections"
              className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-700 sm:inline-block"
            >
              查看最新合辑
            </a>
            <button
              type="button"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-foreground-900/20 text-lg text-foreground-900 transition-colors hover:border-primary-400 hover:text-primary-600 md:hidden"
            >
              <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
            </button>
          </div>
        </div>

        {open ? (
          <div className="border-t border-foreground-900/10 bg-background-50 md:hidden">
            <nav className="mx-auto flex w-full max-w-[1360px] flex-col px-4 py-2">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={() => setOpen(false)}
                  className="flex cursor-pointer items-center justify-between border-b border-foreground-900/5 py-3 text-sm text-foreground-800 last:border-0"
                >
                  {item.label}
                  <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </a>
              ))}
              <a
                href="#collections"
                onClick={() => setOpen(false)}
                className="mt-3 mb-3 cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-center text-sm text-background-50"
              >
                查看最新合辑
              </a>
            </nav>
          </div>
        ) : null}
      </div>
    </header>
  );
}